export default __webpack_public_path__ + "static/media/Ask_me_for_Help.93e655bb.gif";